import React from 'react';
import { Link } from 'react-router-dom';
import { MainContainer, MainTitle, TitleContainer, ColumnContainer, Column, SimpleLink } from '@beacharound/beacharound-ui';

import beachesDisables from '../../data/pages/beachesDisables';

export default function AccessibilitiesSitemap() {

    const data = beachesDisables?.map((item) => {
        return {
            name: item.title,
            slug: item.slug
        }
    })

    return (
        <MainContainer>
            <TitleContainer>
                <MainTitle text="Mappa del sito - Accessibilità" component="div" />
            </TitleContainer>

             <ColumnContainer flex>
                {data?.map((sitemap, index) => {
                    return (
                        <Column column={2} key={index}>
                            <SimpleLink index={sitemap.slug} text={sitemap.name} to={`/${sitemap.slug}`} component={Link} />
                        </Column>
                    )
                })}
            </ColumnContainer>
        </MainContainer>
    );
}